export const getRoute = (): string => window.location.pathname.replace(/feature\/(.*?)\//, '');

export const getBaseRoute = (): string => {
  const splittedPathname = window.location.pathname.split('/');

  return splittedPathname[1] === 'feature' ? splittedPathname[3] : splittedPathname[1];
};
